import React, { useState } from 'react';
import TextArea from '../../../components/Input/TextArea';
import TextInput from '../../../components/Input/TextInput';
import SelectSearchField from '../../../components/Input/SelectSearchField'
import TextFieldLabel from '../../../components/Input/TextFieldLabel'
import { Link } from 'react-router-dom';

const DetailField = (props) => {
	const { label, value, editMode, onChange, autoFocus, invalid, helperText, helperTextClass, disabled, textArea, type, placeholder, bold, variant, className, maxlength, onClick, style, dropDown, dropDownOptions, size, min, max, noClearable, inputstyle, fullWidth, id, noPlaceholder, renderText, link } = props;
	const cursor = (style && style.cursor) || null
	const [searchTerm, setSearchTerm] = useState("")
	const textValue = renderText ? renderText(value) : value

	return (
		<div className={`detail-field-wrapper${className ? ' ' + className : ''}`} onClick={onClick} style={style}>
			{editMode ? (
				<React.Fragment>
					{textArea ? (
						<TextArea disabled={disabled} maxlength={maxlength} {...props} onChange={(e) => onChange(e.target.value)} value={value} className="transition-fade-up-slow"></TextArea>
					) : dropDown ? (
						<div className={`text-input-wrapper${invalid ? " text-input-wrapper-invalid" : ""}`}>
							<TextFieldLabel>{label}</TextFieldLabel>
							<SelectSearchField
								placeholder={noPlaceholder ? null : placeholder ? placeholder : "Select a city"}
								value={value ? {value:value, label: value} : searchTerm}
								noIcon
								isClearable={!noClearable}
								options={dropDownOptions && dropDownOptions.map(((option) => { return { value: option.name, label: option.name } }))}
								onChange={(e) => { setSearchTerm(e); onChange(e ? e.value : null) }}
								onClear={() => { setSearchTerm(null); onChange(null)}}
								disabled={disabled}
							/>
							{helperText && <div className={helperTextClass ? helperTextClass : "text-input-helper-text"}>{helperText}</div>}
						</div>
					) : (
						<TextInput
							disabled={disabled}
							invalid={invalid}
							helperText={helperText}
							helperTextClass={helperTextClass}
							autoFocus={autoFocus}
							label={label}
							placeholder={noPlaceholder ? null : placeholder || label}
							value={value}
							onChange={onChange}
							className="transition-fade-up-slow"
							type={type}
							variant={variant}
							size={size}
							max={max}
							min={min}
							inputstyle={inputstyle}
							fullWidth={fullWidth}
							id={id}
						/>
					)}
				</React.Fragment>
			) : (
				<React.Fragment>
					{label ? <label className="colour-text-label-grey transition-fade-up" style={{ cursor: cursor }}>{label}</label> : ""}
					<div className={`${label ? "mt-s " : ""}transition-fade-up-slow${bold ? " font-weight-semi-bold" : ""}`} style={{ wordBreak: "break-word" }}>
						{link ? <Link to={link}>
						{value ? textValue : "-"}
						</Link> : (value ? textValue : "-")}
						
					</div>
				</React.Fragment>
			)}
		</div>
	);
}

export default DetailField;